import { GroupByType } from '@vgrubs/components';
import { formatDateByGroupByTypeChart } from '@vgrubs/components';
import { lightTheme } from '@vgrubs/components';

export const CustomXAxisTick = ({
  x,
  y,
  payload,
  groupByType,
}: {
  x: number;
  y: number;
  payload: { value: string };
  groupByType: GroupByType;
}) => {
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={14}
        textAnchor="middle"
        fontSize="12px"
        fill={lightTheme.lightGray}
      >
        {formatDateByGroupByTypeChart(payload.value, groupByType)}
      </text>
    </g>
  );
};
